import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Profile() {
  const navigate = useNavigate();
  const [showAddressForm, setShowAddressForm] = useState(false);
  const [editingAddress, setEditingAddress] = useState<number | null>(null);

  const userInfo = {
    name: 'أحمد محمد',
    phone: '+966 50 123 4567',
    email: 'ahmed@example.com',
    avatar: 'https://public.readdy.ai/ai/img_res/ed4681bf85a32c05de45e43166ee6c28.jpg'
  };

  const [addresses, setAddresses] = useState([
    {
      id: 1,
      title: 'المنزل',
      address: 'شارع الملك فهد، حي النخيل، الرياض 12345',
      phone: '+966 50 123 4567',
      isDefault: true
    },
    {
      id: 2,
      title: 'العمل',
      address: 'طريق الملك عبدالعزيز، حي العليا، الرياض 11564',
      phone: '+966 50 123 4567',
      isDefault: false
    }
  ]);

  const menuItems = [
    {
      icon: 'ri-file-list-line',
      title: 'طلباتي',
      subtitle: 'عرض جميع الطلبات',
      action: () => navigate('/orders')
    },
    {
      icon: 'ri-heart-line',
      title: 'المفضلة',
      subtitle: 'المنتجات والمتاجر المفضلة',
      action: () => {}
    },
    {
      icon: 'ri-coupon-line',
      title: 'كوبونات الخصم',
      subtitle: 'عروض وخصومات حصرية',
      action: () => {}
    },
    {
      icon: 'ri-notification-line',
      title: 'الإشعارات',
      subtitle: 'إدارة الإشعارات',
      action: () => {}
    },
    {
      icon: 'ri-customer-service-line',
      title: 'خدمة العملاء',
      subtitle: 'تواصل معنا',
      action: () => {}
    },
    {
      icon: 'ri-settings-line',
      title: 'الإعدادات',
      subtitle: 'إعدادات التطبيق',
      action: () => {}
    }
  ];

  const handleDeleteAddress = (id: number) => {
    setAddresses(prev => prev.filter(addr => addr.id !== id));
  };

  const handleSetDefault = (id: number) => {
    setAddresses(prev => 
      prev.map(addr => ({
        ...addr,
        isDefault: addr.id === id
      }))
    );
  };

  return (
    <div className="min-h-screen bg-gray-50 pb-20">
      {/* الهيدر */}
      <div className="bg-white shadow-sm">
        <div className="flex items-center justify-between p-4 pt-12">
          <button onClick={() => navigate(-1)} className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center">
            <i className="ri-arrow-right-line text-xl"></i>
          </button>
          <h1 className="text-lg font-bold">الملف الشخصي</h1>
          <button className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center">
            <i className="ri-edit-line text-xl"></i>
          </button>
        </div>
      </div>

      <div className="px-4 mt-4 space-y-4">
        {/* معلومات المستخدم */}
        <div className="bg-white rounded-lg shadow-sm p-4">
          <div className="flex items-center space-x-4 space-x-reverse">
            <img
              src={userInfo.avatar}
              alt={userInfo.name}
              className="w-16 h-16 rounded-full object-cover"
            />
            <div className="flex-1">
              <h3 className="font-bold text-gray-800 text-lg">{userInfo.name}</h3>
              <p className="text-gray-600">{userInfo.phone}</p>
              <p className="text-gray-500 text-sm">{userInfo.email}</p>
            </div>
            <div className="bg-green-100 px-3 py-1 rounded-full">
              <span className="text-green-600 text-sm font-medium">عضو ذهبي</span>
            </div>
          </div>
        </div>

        {/* الإحصائيات */}
        <div className="bg-white rounded-lg shadow-sm p-4">
          <div className="grid grid-cols-3 gap-4">
            <div className="text-center">
              <div className="text-2xl font-bold text-green-600">24</div>
              <div className="text-sm text-gray-500">إجمالي الطلبات</div>
            </div>
            <div className="text-center border-x border-gray-100">
              <div className="text-2xl font-bold text-blue-600">1,250</div>
              <div className="text-sm text-gray-500">النقاط</div>
            </div>
            <div className="text-center">
              <div className="text-2xl font-bold text-orange-600">5</div>
              <div className="text-sm text-gray-500">كوبونات</div>
            </div>
          </div>
        </div>

        {/* العناوين */}
        <div className="bg-white rounded-lg shadow-sm p-4">
          <div className="flex items-center justify-between mb-4">
            <h3 className="font-medium text-gray-800">عناويني</h3>
            <button 
              onClick={() => setShowAddressForm(true)}
              className="text-green-500 text-sm font-medium"
            >
              إضافة عنوان
            </button>
          </div>
          
          <div className="space-y-3">
            {addresses.map((address) => (
              <div key={address.id} className="border border-gray-200 rounded-lg p-3">
                <div className="flex items-start justify-between">
                  <div className="flex-1">
                    <div className="flex items-center space-x-2 space-x-reverse mb-1">
                      <h4 className="font-medium text-gray-800">{address.title}</h4>
                      {address.isDefault && (
                        <span className="bg-green-100 text-green-600 text-xs px-2 py-1 rounded">افتراضي</span>
                      )}
                    </div>
                    <p className="text-sm text-gray-600 mb-1">{address.address}</p>
                    <p className="text-sm text-gray-500">{address.phone}</p>
                  </div>
                  <div className="flex space-x-1 space-x-reverse">
                    <button 
                      onClick={() => setEditingAddress(address.id)}
                      className="w-8 h-8 bg-gray-100 rounded-full flex items-center justify-center"
                    >
                      <i className="ri-edit-line text-sm"></i>
                    </button>
                    {!address.isDefault && (
                      <button 
                        onClick={() => handleDeleteAddress(address.id)}
                        className="w-8 h-8 bg-red-100 text-red-600 rounded-full flex items-center justify-center"
                      >
                        <i className="ri-delete-bin-line text-sm"></i>
                      </button>
                    )}
                  </div>
                </div>
                {!address.isDefault && (
                  <button
                    onClick={() => handleSetDefault(address.id)}
                    className="mt-2 text-green-500 text-sm font-medium"
                  >
                    تعيين كافتراضي
                  </button>
                )}
              </div>
            ))}
          </div>
        </div>

        {/* القائمة */}
        <div className="bg-white rounded-lg shadow-sm overflow-hidden">
          {menuItems.map((item, index) => (
            <button
              key={index}
              onClick={item.action}
              className="w-full p-4 flex items-center space-x-3 space-x-reverse border-b border-gray-50 last:border-b-0 hover:bg-gray-50"
            >
              <div className="w-10 h-10 bg-gray-100 rounded-full flex items-center justify-center">
                <i className={`${item.icon} text-lg text-gray-600`}></i>
              </div>
              <div className="flex-1 text-right">
                <h4 className="font-medium text-gray-800">{item.title}</h4>
                <p className="text-sm text-gray-500">{item.subtitle}</p>
              </div>
              <i className="ri-arrow-left-s-line text-gray-400"></i>
            </button>
          ))}
        </div>

        {/* تسجيل الخروج */}
        <button className="w-full bg-red-50 text-red-600 py-3 rounded-lg font-medium">
          تسجيل الخروج
        </button>
      </div>

      {/* نموذج إضافة/تعديل عنوان */}
      {(showAddressForm || editingAddress) && (
        <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-end">
          <div className="bg-white w-full rounded-t-2xl p-4 max-h-96 overflow-y-auto">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-lg font-bold">
                {editingAddress ? 'تعديل العنوان' : 'إضافة عنوان جديد'}
              </h3>
              <button 
                onClick={() => {
                  setShowAddressForm(false);
                  setEditingAddress(null);
                }}
                className="w-8 h-8 bg-gray-100 rounded-full flex items-center justify-center"
              >
                <i className="ri-close-line text-lg"></i>
              </button>
            </div>
            
            <div className="space-y-4">
              <input
                type="text"
                placeholder="عنوان المكان (منزل، عمل، إلخ)"
                className="w-full p-3 border border-gray-200 rounded-lg"
              />
              <input
                type="text"
                placeholder="العنوان التفصيلي"
                className="w-full p-3 border border-gray-200 rounded-lg"
              />
              <input
                type="tel"
                placeholder="رقم الهاتف"
                className="w-full p-3 border border-gray-200 rounded-lg"
              />
              <div className="flex items-center space-x-2 space-x-reverse">
                <input
                  type="checkbox"
                  id="default-address"
                  className="w-4 h-4 text-green-600 border-gray-300 rounded"
                />
                <label htmlFor="default-address" className="text-sm text-gray-600">
                  تعيين كعنوان افتراضي
                </label>
              </div>
              <button
                onClick={() => {
                  setShowAddressForm(false);
                  setEditingAddress(null);
                }}
                className="w-full bg-green-500 text-white py-3 rounded-lg font-medium"
              >
                {editingAddress ? 'حفظ التغييرات' : 'حفظ العنوان'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* شريط التنقل السفلي */}
      <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200">
        <div className="grid grid-cols-4 h-16">
          <button 
            onClick={() => navigate('/home')}
            className="flex flex-col items-center justify-center text-gray-400"
          >
            <i className="ri-home-line text-xl mb-1"></i>
            <span className="text-xs">الرئيسية</span>
          </button>
          <button className="flex flex-col items-center justify-center text-gray-400">
            <i className="ri-search-line text-xl mb-1"></i>
            <span className="text-xs">البحث</span>
          </button>
          <button 
            onClick={() => navigate('/cart')}
            className="flex flex-col items-center justify-center text-gray-400"
          >
            <i className="ri-shopping-cart-line text-xl mb-1"></i>
            <span className="text-xs">السلة</span>
          </button>
          <button className="flex flex-col items-center justify-center text-green-500">
            <i className="ri-user-fill text-xl mb-1"></i>
            <span className="text-xs">حسابي</span>
          </button>
        </div>
      </div>
    </div>
  );
}